import { useState, useEffect, useCallback } from "react";
import { X, Plus, Pencil, Trash2, Save } from "lucide-react";
import api from "@/lib/api";

/* ======= MODAL TIPO CARTÃO ======= */
export function TipoCartaoModal({ open, onClose }) {
  const [items, setItems] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [newItem, setNewItem] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await api.get("/admin/tabelas/tipoCartao");
      setItems(res.data);
    } catch {}
  }, []);

  useEffect(() => { if (open) load(); }, [open, load]);

  const handleSave = async (item) => {
    try {
      await api.put(`/admin/tabelas/tipoCartao/${item.codigo}`, {
        descricao: item.descricao,
        tipo: item.tipo,
        ativo: item.ativo,
      });
      setEditingItem(null);
      load();
    } catch {}
  };

  const handleCreate = async () => {
    if (!newItem?.codigo || !newItem?.descricao) return;
    try {
      await api.post("/admin/tabelas/tipoCartao", newItem);
      setNewItem(null);
      load();
    } catch (err) {
      alert(err.response?.data?.detail || "Erro ao criar");
    }
  };

  const handleDelete = async (codigo) => {
    if (!window.confirm("Excluir este tipo de cartão?")) return;
    try {
      await api.delete(`/admin/tabelas/tipoCartao/${codigo}`);
      load();
    } catch {}
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-brand-dark border border-brand-ice/20 rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-brand-ice/20">
          <h2 className="text-lg font-heading font-bold text-brand-ice">Tipo de Cartão</h2>
          <div className="flex items-center gap-2">
            <button onClick={() => setNewItem({ codigo: "", descricao: "", tipo: "", ativo: true })} className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-green-600 hover:bg-green-500 text-white text-xs font-medium transition-colors">
              <Plus className="w-3 h-3" /> Novo
            </button>
            <button onClick={onClose} className="p-2 rounded-lg text-brand-ice/60 hover:text-brand-ice hover:bg-white/10 transition-colors">
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-4">
          {/* Formulário de novo item */}
          {newItem && (
            <div className="mb-4 p-3 rounded-lg border border-green-500/30 bg-green-500/5 space-y-2">
              <div className="grid grid-cols-12 gap-2">
                <input type="number" placeholder="Cód" value={newItem.codigo} onChange={(e) => setNewItem({ ...newItem, codigo: parseInt(e.target.value) || "" })} className="col-span-2 bg-white/10 border border-brand-ice/20 rounded px-2 py-1.5 text-xs text-brand-ice" />
                <input placeholder="Descrição" value={newItem.descricao} onChange={(e) => setNewItem({ ...newItem, descricao: e.target.value })} className="col-span-5 bg-white/10 border border-brand-ice/20 rounded px-2 py-1.5 text-xs text-brand-ice" />
                <input placeholder="Tipo" value={newItem.tipo} onChange={(e) => setNewItem({ ...newItem, tipo: e.target.value })} className="col-span-3 bg-white/10 border border-brand-ice/20 rounded px-2 py-1.5 text-xs text-brand-ice" />
                <div className="col-span-2 flex items-center gap-1">
                  <button onClick={handleCreate} className="p-1.5 rounded bg-green-600 hover:bg-green-500 text-white"><Save className="w-3.5 h-3.5" /></button>
                  <button onClick={() => setNewItem(null)} className="p-1.5 rounded bg-red-600/50 hover:bg-red-500 text-white"><X className="w-3.5 h-3.5" /></button>
                </div>
              </div>
            </div>
          )}
          {/* Tabela */}
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-brand-ice/10">
                <th className="text-left py-2 px-2 text-brand-ice/60 font-bold w-16">Cód</th>
                <th className="text-left py-2 px-2 text-brand-ice/60 font-bold">Descrição</th>
                <th className="text-left py-2 px-2 text-brand-ice/60 font-bold w-24">Tipo</th>
                <th className="text-center py-2 px-2 text-brand-ice/60 font-bold w-16">Ativo</th>
                <th className="text-right py-2 px-2 text-brand-ice/60 font-bold w-20">Ações</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.codigo} className="border-b border-brand-ice/5 hover:bg-white/5">
                  {editingItem?.codigo === item.codigo ? (
                    <>
                      <td className="py-2 px-2 text-brand-ice font-mono">{item.codigo}</td>
                      <td className="py-2 px-2"><input value={editingItem.descricao} onChange={(e) => setEditingItem({ ...editingItem, descricao: e.target.value })} className="w-full bg-white/10 border border-brand-ice/20 rounded px-2 py-1 text-xs text-brand-ice" /></td>
                      <td className="py-2 px-2"><input value={editingItem.tipo} onChange={(e) => setEditingItem({ ...editingItem, tipo: e.target.value })} className="w-full bg-white/10 border border-brand-ice/20 rounded px-2 py-1 text-xs text-brand-ice" /></td>
                      <td className="py-2 px-2 text-center">
                        <button onClick={() => setEditingItem({ ...editingItem, ativo: !editingItem.ativo })} className={`w-8 h-4 rounded-full flex items-center px-0.5 transition-colors ${editingItem.ativo ? 'bg-green-500' : 'bg-red-500/50'}`}>
                          <div className={`w-3 h-3 rounded-full bg-white transition-transform ${editingItem.ativo ? 'translate-x-4' : 'translate-x-0'}`} />
                        </button>
                      </td>
                      <td className="py-2 px-2 text-right">
                        <div className="flex items-center justify-end gap-1">
                          <button onClick={() => handleSave(editingItem)} className="p-1 rounded text-green-400 hover:bg-green-500/20"><Save className="w-3.5 h-3.5" /></button>
                          <button onClick={() => setEditingItem(null)} className="p-1 rounded text-red-400 hover:bg-red-500/20"><X className="w-3.5 h-3.5" /></button>
                        </div>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="py-2 px-2 text-brand-ice font-mono">{item.codigo}</td>
                      <td className="py-2 px-2 text-brand-ice">{item.descricao}</td>
                      <td className="py-2 px-2 text-brand-ice/60">{item.tipo}</td>
                      <td className="py-2 px-2 text-center">
                        <span className={`inline-block w-2 h-2 rounded-full ${item.ativo ? 'bg-green-400' : 'bg-red-400'}`} />
                      </td>
                      <td className="py-2 px-2 text-right">
                        <div className="flex items-center justify-end gap-1">
                          <button onClick={() => setEditingItem({ ...item })} className="p-1 rounded text-brand-ice/60 hover:text-brand-ice hover:bg-white/10"><Pencil className="w-3.5 h-3.5" /></button>
                          <button onClick={() => handleDelete(item.codigo)} className="p-1 rounded text-red-400/60 hover:text-red-400 hover:bg-red-500/10"><Trash2 className="w-3.5 h-3.5" /></button>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}


/* ======= MODAL CLASSIFICAÇÃO ======= */
export function ClassificacaoModal({ open, onClose }) {
  const [items, setItems] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [newItem, setNewItem] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await api.get("/admin/tabelas/classificacao");
      setItems(res.data);
    } catch {}
  }, []);

  useEffect(() => { if (open) load(); }, [open, load]);

  const handleSave = async (item) => {
    try {
      await api.put(`/admin/tabelas/classificacao/${item.codigo}`, { descricao: item.descricao });
      setEditingItem(null);
      load();
    } catch {}
  };

  const handleCreate = async () => {
    if (!newItem?.codigo || !newItem?.descricao) return;
    try {
      await api.post("/admin/tabelas/classificacao", newItem);
      setNewItem(null);
      load();
    } catch (err) {
      alert(err.response?.data?.detail || "Erro ao criar");
    }
  };

  const handleDelete = async (codigo) => {
    if (!window.confirm("Excluir esta classificação?")) return;
    try {
      await api.delete(`/admin/tabelas/classificacao/${codigo}`);
      load();
    } catch {}
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-brand-dark border border-brand-ice/20 rounded-xl shadow-2xl w-full max-w-lg max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-brand-ice/20">
          <h2 className="text-lg font-heading font-bold text-brand-ice">Classificação</h2>
          <div className="flex items-center gap-2">
            <button onClick={() => setNewItem({ codigo: "", descricao: "" })} className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-green-600 hover:bg-green-500 text-white text-xs font-medium transition-colors">
              <Plus className="w-3 h-3" /> Novo
            </button>
            <button onClick={onClose} className="p-2 rounded-lg text-brand-ice/60 hover:text-brand-ice hover:bg-white/10 transition-colors">
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-4">
          {/* Formulário de novo item */}
          {newItem && (
            <div className="mb-4 p-3 rounded-lg border border-green-500/30 bg-green-500/5 space-y-2">
              <div className="grid grid-cols-12 gap-2">
                <input type="number" placeholder="Cód" value={newItem.codigo} onChange={(e) => setNewItem({ ...newItem, codigo: parseInt(e.target.value) || "" })} className="col-span-3 bg-white/10 border border-brand-ice/20 rounded px-2 py-1.5 text-xs text-brand-ice" />
                <input placeholder="Descrição" value={newItem.descricao} onChange={(e) => setNewItem({ ...newItem, descricao: e.target.value })} className="col-span-7 bg-white/10 border border-brand-ice/20 rounded px-2 py-1.5 text-xs text-brand-ice" />
                <div className="col-span-2 flex items-center gap-1">
                  <button onClick={handleCreate} className="p-1.5 rounded bg-green-600 hover:bg-green-500 text-white"><Save className="w-3.5 h-3.5" /></button>
                  <button onClick={() => setNewItem(null)} className="p-1.5 rounded bg-red-600/50 hover:bg-red-500 text-white"><X className="w-3.5 h-3.5" /></button>
                </div>
              </div>
            </div>
          )}
          {/* Tabela */}
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-brand-ice/10">
                <th className="text-left py-2 px-2 text-brand-ice/60 font-bold w-16">Cód</th>
                <th className="text-left py-2 px-2 text-brand-ice/60 font-bold">Descrição</th>
                <th className="text-right py-2 px-2 text-brand-ice/60 font-bold w-20">Ações</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.codigo} className="border-b border-brand-ice/5 hover:bg-white/5">
                  {editingItem?.codigo === item.codigo ? (
                    <>
                      <td className="py-2 px-2 text-brand-ice font-mono">{item.codigo}</td>
                      <td className="py-2 px-2"><input value={editingItem.descricao} onChange={(e) => setEditingItem({ ...editingItem, descricao: e.target.value })} className="w-full bg-white/10 border border-brand-ice/20 rounded px-2 py-1 text-xs text-brand-ice" /></td>
                      <td className="py-2 px-2 text-right">
                        <div className="flex items-center justify-end gap-1">
                          <button onClick={() => handleSave(editingItem)} className="p-1 rounded text-green-400 hover:bg-green-500/20"><Save className="w-3.5 h-3.5" /></button>
                          <button onClick={() => setEditingItem(null)} className="p-1 rounded text-red-400 hover:bg-red-500/20"><X className="w-3.5 h-3.5" /></button>
                        </div>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="py-2 px-2 text-brand-ice font-mono">{item.codigo}</td>
                      <td className="py-2 px-2 text-brand-ice">{item.descricao}</td>
                      <td className="py-2 px-2 text-right">
                        <div className="flex items-center justify-end gap-1">
                          <button onClick={() => setEditingItem({ ...item })} className="p-1 rounded text-brand-ice/60 hover:text-brand-ice hover:bg-white/10"><Pencil className="w-3.5 h-3.5" /></button>
                          <button onClick={() => handleDelete(item.codigo)} className="p-1 rounded text-red-400/60 hover:text-red-400 hover:bg-red-500/10"><Trash2 className="w-3.5 h-3.5" /></button>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}


/* ======= MODAL FUNÇÕES ======= */
export function FuncoesModal({ open, onClose }) {
  const [items, setItems] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [newItem, setNewItem] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await api.get("/admin/tabelas/funcoes");
      setItems(res.data);
    } catch {}
  }, []);

  useEffect(() => { if (open) load(); }, [open, load]);

  const handleSave = async (item) => {
    try {
      await api.put(`/admin/tabelas/funcoes/${item.codigo}`, { descricao: item.descricao });
      setEditingItem(null);
      load();
    } catch {}
  };

  const handleCreate = async () => {
    if (!newItem?.codigo || !newItem?.descricao) return;
    try {
      await api.post("/admin/tabelas/funcoes", newItem);
      setNewItem(null);
      load();
    } catch (err) {
      alert(err.response?.data?.detail || "Erro ao criar");
    }
  };

  const handleDelete = async (codigo) => {
    if (!window.confirm("Excluir esta função?")) return;
    try {
      await api.delete(`/admin/tabelas/funcoes/${codigo}`);
      load();
    } catch {}
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-brand-dark border border-brand-ice/20 rounded-xl shadow-2xl w-full max-w-lg max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-brand-ice/20">
          <h2 className="text-lg font-heading font-bold text-brand-ice">Funções</h2>
          <div className="flex items-center gap-2">
            <button onClick={() => setNewItem({ codigo: "", descricao: "" })} className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-green-600 hover:bg-green-500 text-white text-xs font-medium transition-colors">
              <Plus className="w-3 h-3" /> Novo
            </button>
            <button onClick={onClose} className="p-2 rounded-lg text-brand-ice/60 hover:text-brand-ice hover:bg-white/10 transition-colors">
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-4">
          {newItem && (
            <div className="mb-4 p-3 rounded-lg border border-green-500/30 bg-green-500/5">
              <div className="grid grid-cols-12 gap-2">
                <input type="number" placeholder="Cód" value={newItem.codigo} onChange={(e) => setNewItem({ ...newItem, codigo: parseInt(e.target.value) || "" })} className="col-span-3 bg-white/10 border border-brand-ice/20 rounded px-2 py-1.5 text-xs text-brand-ice" />
                <input placeholder="Descrição" value={newItem.descricao} onChange={(e) => setNewItem({ ...newItem, descricao: e.target.value })} className="col-span-7 bg-white/10 border border-brand-ice/20 rounded px-2 py-1.5 text-xs text-brand-ice" />
                <div className="col-span-2 flex items-center gap-1">
                  <button onClick={handleCreate} className="p-1.5 rounded bg-green-600 hover:bg-green-500 text-white"><Save className="w-3.5 h-3.5" /></button>
                  <button onClick={() => setNewItem(null)} className="p-1.5 rounded bg-red-600/50 hover:bg-red-500 text-white"><X className="w-3.5 h-3.5" /></button>
                </div>
              </div>
            </div>
          )}
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-brand-ice/10">
                <th className="text-left py-2 px-2 text-brand-ice/60 font-bold w-16">Cód</th>
                <th className="text-left py-2 px-2 text-brand-ice/60 font-bold">Descrição</th>
                <th className="text-right py-2 px-2 text-brand-ice/60 font-bold w-20">Ações</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.codigo} className="border-b border-brand-ice/5 hover:bg-white/5">
                  {editingItem?.codigo === item.codigo ? (
                    <>
                      <td className="py-2 px-2 text-brand-ice font-mono">{item.codigo}</td>
                      <td className="py-2 px-2"><input value={editingItem.descricao} onChange={(e) => setEditingItem({ ...editingItem, descricao: e.target.value })} className="w-full bg-white/10 border border-brand-ice/20 rounded px-2 py-1 text-xs text-brand-ice" /></td>
                      <td className="py-2 px-2 text-right">
                        <div className="flex items-center justify-end gap-1">
                          <button onClick={() => handleSave(editingItem)} className="p-1 rounded text-green-400 hover:bg-green-500/20"><Save className="w-3.5 h-3.5" /></button>
                          <button onClick={() => setEditingItem(null)} className="p-1 rounded text-red-400 hover:bg-red-500/20"><X className="w-3.5 h-3.5" /></button>
                        </div>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="py-2 px-2 text-brand-ice font-mono">{item.codigo}</td>
                      <td className="py-2 px-2 text-brand-ice">{item.descricao}</td>
                      <td className="py-2 px-2 text-right">
                        <div className="flex items-center justify-end gap-1">
                          <button onClick={() => setEditingItem({ ...item })} className="p-1 rounded text-brand-ice/60 hover:text-brand-ice hover:bg-white/10"><Pencil className="w-3.5 h-3.5" /></button>
                          <button onClick={() => handleDelete(item.codigo)} className="p-1 rounded text-red-400/60 hover:text-red-400 hover:bg-red-500/10"><Trash2 className="w-3.5 h-3.5" /></button>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}


/* ======= MODAL PARENTESCOS ======= */
export function ParentescosModal({ open, onClose }) {
  const [items, setItems] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [newItem, setNewItem] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await api.get("/admin/tabelas/parentescos");
      setItems(res.data);
    } catch {}
  }, []);

  useEffect(() => { if (open) load(); }, [open, load]);

  const handleSave = async (item) => {
    try {
      await api.put(`/admin/tabelas/parentescos/${item.codParentesco}`, { descParentesco: item.descParentesco });
      setEditingItem(null);
      load();
    } catch {}
  };

  const handleCreate = async () => {
    if (!newItem?.codParentesco || !newItem?.descParentesco) return;
    try {
      await api.post("/admin/tabelas/parentescos", newItem);
      setNewItem(null);
      load();
    } catch (err) {
      alert(err.response?.data?.detail || "Erro ao criar");
    }
  };

  const handleDelete = async (codigo) => {
    if (!window.confirm("Excluir este parentesco?")) return;
    try {
      await api.delete(`/admin/tabelas/parentescos/${codigo}`);
      load();
    } catch {}
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-brand-dark border border-brand-ice/20 rounded-xl shadow-2xl w-full max-w-lg max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-brand-ice/20">
          <h2 className="text-lg font-heading font-bold text-brand-ice">Parentescos</h2>
          <div className="flex items-center gap-2">
            <button onClick={() => setNewItem({ codParentesco: "", descParentesco: "" })} className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-green-600 hover:bg-green-500 text-white text-xs font-medium transition-colors">
              <Plus className="w-3 h-3" /> Novo
            </button>
            <button onClick={onClose} className="p-2 rounded-lg text-brand-ice/60 hover:text-brand-ice hover:bg-white/10 transition-colors">
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-4">
          {newItem && (
            <div className="mb-4 p-3 rounded-lg border border-green-500/30 bg-green-500/5">
              <div className="grid grid-cols-12 gap-2">
                <input type="number" placeholder="Cód" value={newItem.codParentesco} onChange={(e) => setNewItem({ ...newItem, codParentesco: parseInt(e.target.value) || "" })} className="col-span-3 bg-white/10 border border-brand-ice/20 rounded px-2 py-1.5 text-xs text-brand-ice" />
                <input placeholder="Descrição" value={newItem.descParentesco} onChange={(e) => setNewItem({ ...newItem, descParentesco: e.target.value })} className="col-span-7 bg-white/10 border border-brand-ice/20 rounded px-2 py-1.5 text-xs text-brand-ice" />
                <div className="col-span-2 flex items-center gap-1">
                  <button onClick={handleCreate} className="p-1.5 rounded bg-green-600 hover:bg-green-500 text-white"><Save className="w-3.5 h-3.5" /></button>
                  <button onClick={() => setNewItem(null)} className="p-1.5 rounded bg-red-600/50 hover:bg-red-500 text-white"><X className="w-3.5 h-3.5" /></button>
                </div>
              </div>
            </div>
          )}
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-brand-ice/10">
                <th className="text-left py-2 px-2 text-brand-ice/60 font-bold w-16">Cód</th>
                <th className="text-left py-2 px-2 text-brand-ice/60 font-bold">Descrição</th>
                <th className="text-right py-2 px-2 text-brand-ice/60 font-bold w-20">Ações</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.codParentesco} className="border-b border-brand-ice/5 hover:bg-white/5">
                  {editingItem?.codParentesco === item.codParentesco ? (
                    <>
                      <td className="py-2 px-2 text-brand-ice font-mono">{item.codParentesco}</td>
                      <td className="py-2 px-2"><input value={editingItem.descParentesco} onChange={(e) => setEditingItem({ ...editingItem, descParentesco: e.target.value })} className="w-full bg-white/10 border border-brand-ice/20 rounded px-2 py-1 text-xs text-brand-ice" /></td>
                      <td className="py-2 px-2 text-right">
                        <div className="flex items-center justify-end gap-1">
                          <button onClick={() => handleSave(editingItem)} className="p-1 rounded text-green-400 hover:bg-green-500/20"><Save className="w-3.5 h-3.5" /></button>
                          <button onClick={() => setEditingItem(null)} className="p-1 rounded text-red-400 hover:bg-red-500/20"><X className="w-3.5 h-3.5" /></button>
                        </div>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="py-2 px-2 text-brand-ice font-mono">{item.codParentesco}</td>
                      <td className="py-2 px-2 text-brand-ice">{item.descParentesco}</td>
                      <td className="py-2 px-2 text-right">
                        <div className="flex items-center justify-end gap-1">
                          <button onClick={() => setEditingItem({ ...item })} className="p-1 rounded text-brand-ice/60 hover:text-brand-ice hover:bg-white/10"><Pencil className="w-3.5 h-3.5" /></button>
                          <button onClick={() => handleDelete(item.codParentesco)} className="p-1 rounded text-red-400/60 hover:text-red-400 hover:bg-red-500/10"><Trash2 className="w-3.5 h-3.5" /></button>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}


/* ======= MODAL EVENTO MSG ======= */
export function EventoMsgModal({ open, onClose }) {
  const [items, setItems] = useState([]);
  const [editingItem, setEditingItem] = useState(null);
  const [newItem, setNewItem] = useState(null);
  const [showExemplo, setShowExemplo] = useState(false);

  const load = useCallback(async () => {
    try {
      const res = await api.get("/admin/tabelas/eventomsg");
      setItems(res.data);
    } catch {}
  }, []);

  useEffect(() => { if (open) load(); }, [open, load]);

  const handleSave = async (item) => {
    try {
      await api.put(`/admin/tabelas/eventomsg/${item.EventoStatus}`, {
        DescEvento: item.DescEvento,
        SeRegistraAcesso: item.SeRegistraAcesso,
        SentidodoAcesso: item.SentidodoAcesso,
      });
      setEditingItem(null);
      load();
    } catch {}
  };

  const handleCreate = async () => {
    if (!newItem?.EventoStatus && newItem?.EventoStatus !== 0) return;
    if (!newItem?.DescEvento) return;
    try {
      await api.post("/admin/tabelas/eventomsg", newItem);
      setNewItem(null);
      load();
    } catch (err) {
      alert(err.response?.data?.detail || "Erro ao criar");
    }
  };

  const handleDelete = async (codigo) => {
    if (!window.confirm("Excluir este evento?")) return;
    try {
      await api.delete(`/admin/tabelas/eventomsg/${codigo}`);
      load();
    } catch {}
  };

  const handleImport = async () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = ".json,.csv,.txt";
    input.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      // Perguntar se deve excluir dados atuais
      const excluir = window.confirm("Deseja EXCLUIR os dados atuais antes de importar?\n\nSIM = Limpar tudo e importar\nNÃO = Adicionar/atualizar sobre os existentes");

      // Ler arquivo tentando UTF-8 primeiro, senão Windows-1252 (Latin1)
      let text;
      try {
        text = await file.text(); // UTF-8
        if (text.includes("\ufffd")) throw new Error("encoding"); // caractere de substituição = encoding errado
      } catch {
        // Fallback: ler como Windows-1252 (padrão SQL Server BR)
        const buffer = await file.arrayBuffer();
        const decoder = new TextDecoder("windows-1252");
        text = decoder.decode(buffer);
      }
      let data;
      if (file.name.endsWith(".json")) {
        data = JSON.parse(text);
      } else {
        // CSV/TXT separado por ponto-e-vírgula (padrão SQL Server)
        const lines = text.trim().split("\n").map(l => l.trim()).filter(l => l);
        const header = lines[0].split(";").map(h => h.trim().replace(/"/g, ""));
        data = lines.slice(1).map(line => {
          const vals = line.split(";").map(v => v.trim().replace(/"/g, ""));
          const obj = {};
          header.forEach((h, i) => {
            const val = vals[i] || "";
            if (h === "EventoStatus") {
              obj[h] = parseInt(val) || 0;
            } else if (h === "SeRegistraAcesso") {
              obj[h] = val === "1" || val.toLowerCase() === "true";
            } else {
              obj[h] = val === "NULL" ? "" : val;
            }
          });
          return obj;
        }).filter(obj => obj.DescEvento);
      }
      try {
        const res = await api.post(`/admin/tabelas/eventomsg/importar?excluir=${excluir}`, data);
        alert(`Importados: ${res.data.count} registros${excluir ? " (dados anteriores excluídos)" : ""}`);
        load();
      } catch (err) {
        alert("Erro na importação: " + (err.response?.data?.detail || err.message));
      }
    };
    input.click();
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-brand-dark border border-brand-ice/20 rounded-xl shadow-2xl w-full max-w-3xl max-h-[80vh] flex flex-col">
        <div className="flex items-center justify-between px-6 py-4 border-b border-brand-ice/20">
          <h2 className="text-lg font-heading font-bold text-brand-ice">Evento Msg</h2>
          <div className="flex items-center gap-2">
            <button onClick={() => setShowExemplo(true)} className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-brand-ice/10 hover:bg-brand-ice/20 text-brand-ice/70 text-xs font-medium transition-colors">
              Exemplo
            </button>
            <button onClick={handleImport} className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-blue-600 hover:bg-blue-500 text-white text-xs font-medium transition-colors">
              Importar
            </button>
            <button onClick={() => setNewItem({ EventoStatus: "", DescEvento: "", SeRegistraAcesso: false, SentidodoAcesso: "" })} className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-green-600 hover:bg-green-500 text-white text-xs font-medium transition-colors">
              <Plus className="w-3 h-3" /> Novo
            </button>
            <button onClick={onClose} className="p-2 rounded-lg text-brand-ice/60 hover:text-brand-ice hover:bg-white/10 transition-colors">
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-4">
          {newItem && (
            <div className="mb-4 p-3 rounded-lg border border-green-500/30 bg-green-500/5">
              <div className="grid grid-cols-12 gap-2">
                <input type="number" placeholder="Status" value={newItem.EventoStatus} onChange={(e) => setNewItem({ ...newItem, EventoStatus: parseInt(e.target.value) || "" })} className="col-span-2 bg-white/10 border border-brand-ice/20 rounded px-2 py-1.5 text-xs text-brand-ice" />
                <input placeholder="Descrição" value={newItem.DescEvento} onChange={(e) => setNewItem({ ...newItem, DescEvento: e.target.value })} className="col-span-4 bg-white/10 border border-brand-ice/20 rounded px-2 py-1.5 text-xs text-brand-ice" />
                <div className="col-span-2 flex items-center gap-1">
                  <button onClick={() => setNewItem({ ...newItem, SeRegistraAcesso: !newItem.SeRegistraAcesso })} className={`w-8 h-4 rounded-full flex items-center px-0.5 transition-colors ${newItem.SeRegistraAcesso ? 'bg-green-500' : 'bg-red-500/50'}`}>
                    <div className={`w-3 h-3 rounded-full bg-white transition-transform ${newItem.SeRegistraAcesso ? 'translate-x-4' : 'translate-x-0'}`} />
                  </button>
                  <span className="text-[10px] text-brand-ice/50">Reg.</span>
                </div>
                <input placeholder="Sentido" value={newItem.SentidodoAcesso} onChange={(e) => setNewItem({ ...newItem, SentidodoAcesso: e.target.value.substring(0, 2) })} maxLength={2} className="col-span-2 bg-white/10 border border-brand-ice/20 rounded px-2 py-1.5 text-xs text-brand-ice" />
                <div className="col-span-2 flex items-center gap-1">
                  <button onClick={handleCreate} className="p-1.5 rounded bg-green-600 hover:bg-green-500 text-white"><Save className="w-3.5 h-3.5" /></button>
                  <button onClick={() => setNewItem(null)} className="p-1.5 rounded bg-red-600/50 hover:bg-red-500 text-white"><X className="w-3.5 h-3.5" /></button>
                </div>
              </div>
            </div>
          )}
          <table className="w-full text-xs">
            <thead>
              <tr className="border-b border-brand-ice/10">
                <th className="text-left py-2 px-2 text-brand-ice/60 font-bold w-16">Status</th>
                <th className="text-left py-2 px-2 text-brand-ice/60 font-bold">Descrição</th>
                <th className="text-center py-2 px-2 text-brand-ice/60 font-bold w-16">Reg.</th>
                <th className="text-center py-2 px-2 text-brand-ice/60 font-bold w-16">Sentido</th>
                <th className="text-right py-2 px-2 text-brand-ice/60 font-bold w-20">Ações</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.EventoStatus} className="border-b border-brand-ice/5 hover:bg-white/5">
                  {editingItem?.EventoStatus === item.EventoStatus ? (
                    <>
                      <td className="py-2 px-2 text-brand-ice font-mono">{item.EventoStatus}</td>
                      <td className="py-2 px-2"><input value={editingItem.DescEvento} onChange={(e) => setEditingItem({ ...editingItem, DescEvento: e.target.value })} className="w-full bg-white/10 border border-brand-ice/20 rounded px-2 py-1 text-xs text-brand-ice" /></td>
                      <td className="py-2 px-2 text-center">
                        <button onClick={() => setEditingItem({ ...editingItem, SeRegistraAcesso: !editingItem.SeRegistraAcesso })} className={`w-8 h-4 rounded-full flex items-center px-0.5 transition-colors mx-auto ${editingItem.SeRegistraAcesso ? 'bg-green-500' : 'bg-red-500/50'}`}>
                          <div className={`w-3 h-3 rounded-full bg-white transition-transform ${editingItem.SeRegistraAcesso ? 'translate-x-4' : 'translate-x-0'}`} />
                        </button>
                      </td>
                      <td className="py-2 px-2 text-center"><input value={editingItem.SentidodoAcesso} onChange={(e) => setEditingItem({ ...editingItem, SentidodoAcesso: e.target.value.substring(0, 2) })} maxLength={2} className="w-full bg-white/10 border border-brand-ice/20 rounded px-2 py-1 text-xs text-brand-ice text-center" /></td>
                      <td className="py-2 px-2 text-right">
                        <div className="flex items-center justify-end gap-1">
                          <button onClick={() => handleSave(editingItem)} className="p-1 rounded text-green-400 hover:bg-green-500/20"><Save className="w-3.5 h-3.5" /></button>
                          <button onClick={() => setEditingItem(null)} className="p-1 rounded text-red-400 hover:bg-red-500/20"><X className="w-3.5 h-3.5" /></button>
                        </div>
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="py-2 px-2 text-brand-ice font-mono">{item.EventoStatus}</td>
                      <td className="py-2 px-2 text-brand-ice">{item.DescEvento}</td>
                      <td className="py-2 px-2 text-center">
                        <span className={`inline-block w-2 h-2 rounded-full ${item.SeRegistraAcesso ? 'bg-green-400' : 'bg-red-400'}`} />
                      </td>
                      <td className="py-2 px-2 text-center text-brand-ice/60 font-mono">{item.SentidodoAcesso || "-"}</td>
                      <td className="py-2 px-2 text-right">
                        <div className="flex items-center justify-end gap-1">
                          <button onClick={() => setEditingItem({ ...item })} className="p-1 rounded text-brand-ice/60 hover:text-brand-ice hover:bg-white/10"><Pencil className="w-3.5 h-3.5" /></button>
                          <button onClick={() => handleDelete(item.EventoStatus)} className="p-1 rounded text-red-400/60 hover:text-red-400 hover:bg-red-500/10"><Trash2 className="w-3.5 h-3.5" /></button>
                        </div>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
          {items.length === 0 && (
            <p className="text-center text-brand-ice/40 text-xs py-8">Nenhum registro. Use "Importar" para carregar dados de um arquivo CSV ou TXT.</p>
          )}
        </div>

        {/* Popup de Exemplo */}
        {showExemplo && (
          <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[60] p-4">
            <div className="bg-brand-dark border border-brand-ice/20 rounded-xl shadow-2xl w-full max-w-2xl max-h-[70vh] flex flex-col">
              <div className="flex items-center justify-between px-6 py-3 border-b border-brand-ice/20">
                <h3 className="text-sm font-heading font-bold text-brand-ice">Exemplo de Arquivo CSV/TXT</h3>
                <button onClick={() => setShowExemplo(false)} className="p-1.5 rounded-lg text-brand-ice/60 hover:text-brand-ice hover:bg-white/10">
                  <X className="w-4 h-4" />
                </button>
              </div>
              <div className="flex-1 overflow-y-auto px-6 py-4">
                <p className="text-xs text-brand-ice/60 mb-3">Formato: campos separados por ponto-e-v&iacute;rgula (;). Primeira linha com o nome dos campos. Valores NULL s&atilde;o tratados como vazio.</p>
                <pre className="bg-black/30 rounded-lg p-4 text-[10px] text-green-400 font-mono overflow-x-auto leading-relaxed whitespace-pre">
{`EventoStatus;DescEvento;SeRegistraAcesso;SentidodoAcesso
0;Evento Invalido;0;B
1;Entrada concluída;1;E
2;Saída concluída;1;S
3;Acesso não concluido;0;B
4;Acesso Cancelado;0;B
5;Acesso Negado;0;B
84;Acesso Facial;1;E
85;Acesso Palma da Mão;1;E
86;Acesso Facial QRCode|Cartão;1;E`}
                </pre>
                <p className="text-xs text-brand-ice/40 mt-3">Salve como .csv ou .txt e use o bot&atilde;o "Importar".</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
